import { Link, useLocation, useNavigate } from "react-router-dom"
import React, { useEffect, useState ,useRef} from 'react';
import NavBar from './WebPages/NavBar';
import Header from "./WebPages/Header";
import { getCount } from "./Services/Service";
import UserContext from "./context/UserContext";
import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft} from "@fortawesome/free-solid-svg-icons";
function Protected(props) {
    const location = useLocation();
    // console.log(location.pathname.slice(0,9))
    const { Component } = props;
  const {state,updateAny,updateCartCount} = useContext(UserContext)
  const divRef = useRef(null);
  const scrollToTop = () => {
if(location.pathname.slice(0,9)!=="/products")
   divRef.current.scroll({
     top: 0,
     behavior: "smooth"
   });
 };
//  setState({...state,divRef: divRef})
    const nav = useNavigate();
    useEffect(() => {
        // updateAny()
        let isLoggedIn = localStorage.getItem('token') ? localStorage.getItem('token') : 0;
        if(isLoggedIn == '' || isLoggedIn == 0){
            return nav('/auth-login');
        }

        if(isLoggedIn && Component.name == 'Splash'){
            return nav('/home');
        }else if (Component.name == 'Splash') {
            return  nav('/home');
        }
        updateCartCount()
        updateAny()
    },[]);
    useEffect(()=>{
        scrollToTop()

    });

    return (
        
            <div className="home-Class">
                
                    {location.pathname!=="/category" && <div className="header-app">
                        {/* <Header count={state.cartCount}/> */}
                    </div>}
      {/* <div className="circleblurbg"></div> */}
                    <div className={location.pathname!=="/category"?"content-app":"content-app"} ref={divRef}>
                    {/* {location.pathname!=="/home" && location.pathname!=="/cart" && location.pathname!=="/category" && location.pathname.slice(0,9)!=="/products" && <div className="PinCodeLocationForCart__base"> */}
                    {/* {location.pathname!=="/home" && location.pathname!=="/cart" && location.pathname!=="/category" && <div className="PinCodeLocationForCart__base">
  <div className="PinCodeLocationForCart__locationIcon" />
  <div className="PinCodeLocationForCart__shipToDelivery">
    <span onClick={()=>{return nav(-1)}}><FontAwesomeIcon icon={faAngleLeft}/> Back</span> 
    <span className="PinCodeLocationForCart__pinCodeSpan" />
  </div>
</div>} */}
                        <Component/>
                    </div>

                    {/* <NavBar count={state.cartCount}/> */}
            </div>
        
        
    )
}

export default Protected;